import VCarousel from './VCarousel'
import VCarouselItem from './VCarouselItem'

export default {
  VCarousel,
  VCarouselItem
}



// WEBPACK FOOTER //
// ./src/components/carousel/index.js